import {
  FilterDisclosure,
  FilterFooter,
  FilterListbox,
  FilterOptionCheckbox,
  FilterPopover,
} from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import {
  PROMOTION_TYPE,
  type CalculatorType,
  type SimplifiedPromotion,
} from 'typings'
import { usePromotionsFilterMultipleState } from '../useFiltersState'

function filterByType(
  promotion: SimplifiedPromotion,
  types: CalculatorType[] | undefined
) {
  if (!types || !types.length) return true

  return types.includes(promotion.type)
}

export function FilterByPromotionType() {
  const { formatMessage } = useIntl()

  const state = usePromotionsFilterMultipleState({
    id: 'promotionType',
    filterFn: (item) =>
      filterByType(
        item,
        state.appliedItems.map((x) => x.id as CalculatorType)
      ),
  })

  const options: Array<{ id: CalculatorType; label: string }> = [
    {
      id: PROMOTION_TYPE.REGULAR,
      label: formatMessage({
        id: 'admin/promotions.list.promotion-type.regular',
      }),
    },
    {
      id: PROMOTION_TYPE.BUY_TOGETHER,
      label: formatMessage({
        id: 'admin/promotions.list.promotion-type.combo',
      }),
    },
    {
      id: PROMOTION_TYPE.MORE_FOR_LESS,
      label: formatMessage({
        id: 'admin/promotions.list.promotion-type.more-for-less',
      }),
    },
    {
      id: PROMOTION_TYPE.PROGRESSIVE,
      label: formatMessage({
        id: 'admin/promotions.list.promotion-type.progressive',
      }),
    },
    {
      id: PROMOTION_TYPE.BUY_AND_WIN,
      label: formatMessage({
        id: 'admin/promotions.list.promotion-type.buy-and-win',
      }),
    },
    {
      id: PROMOTION_TYPE.CAMPAIGN,
      label: formatMessage({
        id: 'admin/promotions.list.promotion-type.campaign',
      }),
    },
  ]

  return (
    <>
      <FilterDisclosure state={state}>
        {formatMessage({ id: 'admin/promotions.list.type' })}
      </FilterDisclosure>
      <FilterPopover state={state}>
        <FilterListbox>
          {options.map((item) => (
            <FilterOptionCheckbox key={item.id} {...item} value={item.id} />
          ))}
        </FilterListbox>
        <FilterFooter />
      </FilterPopover>
    </>
  )
}
